export default {
  state: {
    desktop: true
  },
  getters: {
    isDesktop(state) {
      return state.desktop;
    }
  },
  mutations: {
    makeDesktop(state, payload) {
      state.desktop = payload;
    }
  }
};
